// extracted by mini-css-extract-plugin
export default {"appContent-Container":"AppContent_appContent-Container__SaE+r"};